module.exports = __webpack_public_path__ + "img/bg-poster-2.c9dc0ea1.webp";